import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaSpinner } from 'react-icons/fa';
import Cookies from 'js-cookie';
import { Link, useNavigate } from 'react-router-dom';

const OtpPage = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resendTime, setResendTime] = useState(90);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleChange = (index, event) => {
    const value = event.target.value;
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);


    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (index, event) => {
    if (event.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };
  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData('Text');
    if (!/^\d{6}$/.test(pasteData)) return;

    const newOtp = pasteData.split('');
    setOtp(newOtp);

    const lastInput = document.getElementById(`otp-5`);
    if (lastInput) lastInput.focus();

    e.preventDefault();
  };


  // const handleOtpChange = (e) => {
  //   setOtp(e.target.value);
  //   setError('');
  // };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    const otpString = otp.join("");

    if (!otpString) {
      setError('Please enter OTP');
      return;
    }

    if (otpString.length !== 6) {
      setError('OTP must be 6 digits.');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_BASE_URL}/check-otp`, { otp: otpString }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.status === "Success") {
        navigate('/resetpassword');
      } else {
        setError('Invalid OTP. Please try again.');
      }
    } catch (err) {
      console.error('Error verifying OTP:', err);
      setError('Error verifying OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  const handleResendOtp = async () => {
    setIsResendDisabled(true);
    setResendTime(10);
    setError('');
    setOtp(["", "", "", "", "", ""]);

    const email = Cookies.get('email');
    if (!email) {
      setError('No email found. Please start the process again.');
      return;
    }
    try {
      await axios.post(`${API_BASE_URL}forgot-password/request-otp`, { email });

    } catch (err) {
      console.error('Error resending OTP:', err);
      setError('Error resending OTP. Please try again.');
    }
  };

  useEffect(() => {
    if (resendTime > 0) {
      const timer = setTimeout(() => setResendTime(resendTime - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setIsResendDisabled(false);
    }
  }, [resendTime]);

  return (

    <div className="container">
      <div className="login-page otp-page" id='otp-page'>
        <h2 className='text-center'>OTP Verification</h2>
        <div className="form rounded-2 white-box-shadow">
          <form className="login-form" onSubmit={handleVerifyOtp}>
            <div className="form-group">
              <div className="form-field">
                <label htmlFor="otp" className="form-label w-100">OTP sent to registered Email </label>
                <div className="otp-boxes">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      id={`otp-${index}`}
                      type="text"
                      className="otp-input"
                      value={digit}
                      maxLength={1}
                      onChange={(e) => handleChange(index, e)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                      onPaste={index === 0 ? handlePaste : undefined}
                    />
                  ))}
                </div>
                {error && (<p className="error-message">{error}</p>)}
              </div>
            </div>
            <div className="form-group form-btns mt-3">
              <div className="form-field">
                <button type="submit" disabled={loading} className="ls-btn">
                  {loading ? <><FaSpinner className="spin me-2" /> Verifying...</> : "Verify OTP"}
                </button>
              </div>
            </div>
          </form>

          <div className="mt-3">
            <div className="d-flex justify-content-center align-items-center">
              {resendTime > 0 && <span className="resend-timer">{resendTime}s</span>}
            </div>
            {resendTime === 0 && (
              <div className='d-flex justify-content-between'>
                <p className='m-0'>Didn't receive the OTP?</p>
                <a href="#" onClick={handleResendOtp} className='resend-otp-link'>
                  Resend OTP
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtpPage;
